import $ from 'jquery';
import { MindboxCarousel } from './mindbox-carousel';

export class MindboxPopularRecommendations {
    constructor() {
        this.container = $('[data-mindbox-product="popular"]');
    }

    init() {
        if (this.container.length === 0) {
            return;
        }

        let _self = this;
        $.ajax({
            url: '/ajax/action/widget_mindbox_products/get_popular_products/',
            data: {},
            type: 'GET',
            success: function(result) {
                if (result.data.status !== 'ok') {
                    console.log('mindbox box not render');
                    return;
                }

                _self.container.html(result.html);
                MindboxCarousel.init();
            }
        });
    }
}

jQuery(function() {
    new MindboxPopularRecommendations().init();
});



// WEBPACK FOOTER //
// ./modules/mindbox/mindbox-popular-recommendations.js